<template>
    <div class="device-card relative" :class="{'checked': checked}"
         v-on="checked ?
            { click: () => this.showDeleteModal = true }
            : { click: () => goToRoute('Pwa Intervention Device Report', { deviceId: id }) }
    ">
        <div class="device-icon absolute">
            <img :src="icon" alt="icon" />
        </div>
        <div class="mb-1 font-medium text-sm leading-4">{{ number }}</div>
        <div class="break-normal text-sm leading-none">{{ location }}</div>
        <div class="done-icon" v-if="checked">
            <md-button class="md-icon-button md-small-icon md-rounded-icon my-0 md-success cursor-default">
                <font-awesome-icon class="md-icon" :icon="['fa', 'check-circle']" />
            </md-button>
        </div>
        <md-dialog-confirm class="dialog-pwa"
            :md-active.sync="showDeleteModal"
            :md-content="`Supprimer la fiche de suivi du <strong>dispositif n°${number}</strong> ?`"
            md-confirm-text="Supprimer"
            md-cancel-text="Annuler"
            @md-confirm="deleteReport" />
    </div>
</template>

<script>
import indexedDBMixin from '../../../../../mixins/indexed-db-mixin'
import indexedDBDeviceReportMixin from "@/mixins/indexed-db-device-report-mixin";
export default {
    name: "DeviceCard",
	mixins: [indexedDBMixin, indexedDBDeviceReportMixin],
    props: {
        id: Number,
        number: Number,
        location: String,
	    deviceTypeId: Number,
        checked: Boolean,
        reportId: Number,
        isSameInterventionType: Boolean
    },
    data() {
        return {
			icon: '',
            showDeleteModal: false
        }
    },
    methods: {
		async getDeviceType() {
			const deviceType = await this.fetchDataFromIndexedDB(`pwa/device_types/${this.deviceTypeId}`)
			this.icon = deviceType.value.icon
		},
        async deleteReport() {
			const payload = {
				access_token: JSON.parse(localStorage.getItem('pwa')).access_token,
				device_id: this.id,
				intervention_id: parseInt(this.$route.params.interventionId),
				is_same_intervention_type: this.isSameInterventionType
			}

            try {
                await this.deleteDeviceReport(`pwa/device_report/${payload.device_id}/${payload.intervention_id}/delete`, payload).then(() => {
	                this.$emit('deleted', { deviceId: payload.device_id, isSameInterventionType: payload.is_same_intervention_type })
                })
                await this.$store.dispatch('alerts/success', 'Fiche de suivi supprimée')
            } catch (e) {}
        },
        goToRoute(route, params = {}) {
            this.$router.push({ name: route, params })
        }
    },
	mounted() {
		this.getDeviceType()
	}
}
</script>

<style scoped lang="scss">
.device-card {
    border-radius: 3px;
    background-color: $white;
    padding: .5rem .25rem;

    font-size: .8rem;
    text-align: center;
    line-height: 1;

    width: 100%;
    min-width: 100%;
    max-width: calc(100% / 4);

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    cursor: pointer;

    .device-icon {
        top: 3px;
        left: 3px;

        img {
            max-width: 15px;
            margin: 0;
        }
    }

    .done-icon {
        position: absolute;
        top: -6px;
        right: -3px;

        .md-icon {
            font-size: .6rem !important;
            min-width: .6rem !important;
            height: .6rem !important;
        }

        .md-button {
            min-width: 20px !important;
            min-height: 20px !important;
            line-height: 20px !important;

            &.md-success {
                &:hover {
                    background-color: $brand-success !important;
                    -webkit-box-shadow: 0 2px 2px 0 rgb(76 175 80 / 14%), 0 3px 1px -2px rgb(76 175 80 / 20%), 0 1px 5px 0 rgb(76 175 80 / 12%);
                    box-shadow: 0 2px 2px 0 rgb(76 175 80 / 14%), 0 3px 1px -2px rgb(76 175 80 / 20%), 0 1px 5px 0 rgb(76 175 80 / 12%);
                }
            }
        }
    }
}
</style>
